import {
  Button,
  FormDialog,
  Input,
  Label,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@simplicity/ui";

// eslint-disable-next-line max-lines-per-function -- SIM-1760: admin form dialog with 7 fields + 3 control rows; the JSX is straight-line layout. Low-churn surface; extracting subcomponents would scatter the form definition without readability gain.
export function AddEditUserDialog({
  open,
  onOpenChange,
  editingUserId,
  email,
  name,
  role,
  onSetEmail,
  onSetName,
  onSetRole,
  onConfirm,
  isPending,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  editingUserId: string | null;
  email: string;
  name: string;
  role: string;
  onSetEmail: (v: string) => void;
  onSetName: (v: string) => void;
  onSetRole: (v: string) => void;
  onConfirm: () => void;
  isPending: boolean;
}) {
  return (
    <FormDialog
      open={open}
      onOpenChange={onOpenChange}
      title={editingUserId ? "Edit User" : "Add User"}
      description={
        editingUserId
          ? "Update the user's role."
          : "Enter the user's email to invite them. They'll get access on their next sign-in."
      }
      footer={
        <>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button onClick={onConfirm} disabled={isPending || !email.trim()}>
            {isPending ? "Saving..." : editingUserId ? "Save Changes" : "Add User"}
          </Button>
        </>
      }
    >
      <div className="space-y-3">
        <div>
          <Label htmlFor="user-email" className="text-xs mb-1 block">
            Email
          </Label>
          <Input
            id="user-email"
            value={email}
            onChange={(e) => onSetEmail(e.target.value)}
            placeholder="user@example.com"
            type="email"
            readOnly={!!editingUserId}
            className={editingUserId ? "opacity-50 cursor-not-allowed" : ""}
            autoFocus={!editingUserId}
          />
        </div>
        {!editingUserId && (
          <div>
            <Label htmlFor="user-name" className="text-xs mb-1 block">
              Name (optional)
            </Label>
            <Input
              id="user-name"
              value={name}
              onChange={(e) => onSetName(e.target.value)}
              placeholder="Full name"
            />
          </div>
        )}
        <div>
          <Label htmlFor="user-role" className="text-xs mb-1 block">
            Role
          </Label>
          <Select value={role} onValueChange={onSetRole}>
            <SelectTrigger id="user-role">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="viewer">Viewer</SelectItem>
              <SelectItem value="admin">Admin</SelectItem>
            </SelectContent>
          </Select>
          <p className="text-xs text-muted-foreground mt-1">
            {role === "admin" && "Admins can manage users, groups, and dashboards."}
            {role === "viewer" && "Viewers can only access dashboards assigned to them."}
          </p>
        </div>
      </div>
    </FormDialog>
  );
}
